import React, { useContext } from 'react';
import styles from './styles.css';
import ExistingFundingCard from './ExistingFundingCard';
import CheckFundingCard from './CheckFundingCard';
import { FlowContext } from '../../core/flow-engine';

import { hasExistingAgreements } from '../../flows/shared/testers';

const Contents = () => {
  const { appState } = useContext(FlowContext);
  const {
    store: { existingAgreements = [], accountType }
  } = appState;

  return (
    <div className="grid-container">
      {hasExistingAgreements(existingAgreements) && (
        <div data-e2e="existing-funding-card" className="grid-item">
          <ExistingFundingCard />
        </div>
      )}
      <div data-e2e="check-funding-card" className="grid-item">
        <CheckFundingCard accountType={accountType} />
      </div>
      <style jsx>{styles}</style>
    </div>
  );
};

export default Contents;
